<div class="ui-g">
    <div class="ui-g-12">
        <div *ngIf="(this.api_result.PromiseResult?.success!=null && this.api_result.PromiseResult?.success==true) && 
                (this.api_result.ErrorModel?.message!=null)">
            <div class="alert alert-success">
                {{this.api_result.ErrorModel?.message}}
            </div>
        </div>
        <div *ngIf="(this.api_result.PromiseResult?.success!=null && this.api_result.PromiseResult?.success==false) && 
                (this.api_result.PromiseResult?.error!=null)">
            <div class="alert alert-danger">
                {{this.api_result.PromiseResult?.error.message}}
            </div>
        </div>
        <div *ngIf="(this.api_result.PromiseResult?.success!=null && this.api_result.PromiseResult?.success==false) && 
             (this.api_result.ServerError?.error!=null && this.api_result.ServerError?.statusCode!=500)">
            <div class="alert alert-danger" *ngFor="let message of this.api_result.ServerError?.message">
                {{message}}
            </div>
        </div>
        <div
            *ngIf="(this.api_result.PromiseResult?.success!=null && this.api_result.PromiseResult?.success==false) && 
             (this.api_result.ServerError?.error!=null && this.api_result.ServerError?.message!=null && this.api_result.ServerError?.statusCode==500)">
            <div class="alert alert-danger">
                {{this.api_result.ServerError?.message}}
            </div>
        </div>
        <div *ngIf="(this.api_result.PromiseResult?.success!=null && this.api_result.PromiseResult?.success==false) && 
             (this.api_result.ServerError?.message!=null && this.api_result.ServerError?.statusCode==500)">
            <div class="alert alert-danger">
                {{this.api_result.ServerError?.message}}
            </div>
        </div>
    </div>
</div>